import axios, { AxiosError } from 'axios'

import { TParamsRequest, TResponseType, ServiceResponseError } from './types'

export class BaseServices {
  static request = async <T>({
    headers = { 'Content-Type': 'application/json' },
    pathname,
    method,
    data,
    host,
  }: TParamsRequest): Promise<TResponseType<T>> => {
    let response = {} as TResponseType<T>
    try {
      response = await axios({
        headers: { ...headers },
        url: `${host}${pathname ? `/${pathname}` : ''}`,
        method,
        data,
      })
    } catch (error) {
      const axiosError = error as AxiosError
      throw new ServiceResponseError({
        status: axiosError.response?.status,
        data: axiosError.response?.data,
        message: axiosError.message,
      })
    }
    return response
  }
}
